webpackJsonp([49],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    value: {
      type: Array,
      default: []
    },
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      initialize: null,
      cascaderAreas: []
    };
  },

  computed: {},
  watch: {
    value: function value() {
      if (!_.isEqual(this.value, this.currentValue)) {
        this.currentValue = this.value;
        // 加载value中的市区
        this.initialize.then(this.loadCityAndDistrict);
      }
      if (this.disabled) {
        this.loadCityAndDistrict();
      }
    },
    currentValue: function currentValue() {
      if (!_.isEqual(this.value, this.currentValue)) {
        this.$emit('input', this.currentValue);
      }
    }
  },
  created: function created() {
    var _this = this;

    // 初始化数据
    this.initialize = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!_this.cascaderAreas.length) {
        request('getProvinces').then(function (_ref) {
          var data = _ref.data;

          _this.setProvinces(data);
          resolve();
        }, reject);
      } else {
        resolve();
      }
    });
    // 加载value中的市区
    this.initialize.then(this.loadCityAndDistrict);
  },
  mounted: function mounted() {},

  methods: {
    loadCityAndDistrict: function loadCityAndDistrict() {
      var _this2 = this;

      var value = this.currentValue;
      if (value.length >= 1) {
        this.handleAreaChange(value.slice(0, 1)).then(function () {
          if (value.length > 2) {
            _this2.handleAreaChange(value.slice(0, 2));
          }
        });
      }
    },
    setProvinces: function setProvinces(data) {
      this.cascaderAreas = data.map(function (_ref2) {
        var id = _ref2.id,
            name = _ref2.name;

        return {
          name: name,
          id: id,
          children: []
        };
      });
    },
    setCities: function setCities(provinceIndex) {
      var cascaderAreas = this.cascaderAreas;
      var province = cascaderAreas[provinceIndex];
      return request.alert('getCities', { pid: province.id }).then(function (_ref3) {
        var data = _ref3.data;

        // 设置城市列表
        cascaderAreas[provinceIndex].children = data.map(function (_ref4) {
          var id = _ref4.id,
              name = _ref4.name;

          return {
            name: name,
            id: id,
            children: []
          };
        });
      });
    },
    setDistricts: function setDistricts(provinceIndex, cityIndex) {
      var cascaderAreas = this.cascaderAreas;
      var city = cascaderAreas[provinceIndex].children[cityIndex];
      return request.alert('getDistricts', { pid: city.id }).then(function (_ref5) {
        var data = _ref5.data;

        // 设置县区列表
        cascaderAreas[provinceIndex].children[cityIndex].children = data.map(function (_ref6) {
          var id = _ref6.id,
              name = _ref6.name;

          return { name: name, id: id };
        });
      });
    },
    findProvince: function findProvince(id) {
      return _.findIndex(this.cascaderAreas, { id: id });
    },
    findCity: function findCity(provinceIndex, id) {
      return _.findIndex(this.cascaderAreas[provinceIndex].children, { id: id });
    },
    handleAreaChange: function handleAreaChange(selected) {
      var promise = null;
      var provinceIndex = this.findProvince(selected[0]);
      var province = this.cascaderAreas[provinceIndex];
      switch (selected.length) {
        case 1:
          // 不存在该省份的城市列表则请求获取
          if (!province.children.length) {
            promise = this.setCities(provinceIndex);
          }
          break;
        case 2:
          var cityIndex = this.findCity(provinceIndex, selected[1]);
          var city = province.children[cityIndex];
          // 不存在该城市的县区列表则请求获取
          if (!city.children.length) {
            promise = this.setDistricts(provinceIndex, cityIndex);
          }
          break;
      }
      this.$emit('change', this.currentValue);
      return promise;
    }
  }
});

/***/ }),

/***/ 1531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CascaderDistrict_vue__ = __webpack_require__(1456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50134b28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CascaderDistrict_vue__ = __webpack_require__(1538);
function injectStyle (ssrContext) {
  __webpack_require__(1532)
  __webpack_require__(1534)
  this["$style"] = __webpack_require__(1536)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50134b28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CascaderDistrict_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50134b28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CascaderDistrict_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6dd86c40", content, true, {});

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CascaderDistrict.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("05223b44", content, true, {});

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CascaderDistrict.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("701f92b6", content, true, {});

/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CascaderDistrict.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"size":_vm.size,"disabled":_vm.disabled,"options":_vm.cascaderAreas,"props":{value: 'id',label: 'name'},"placeholder":_vm.placeholder,"filterable":"","clearable":_vm.clearable,"change-on-select":""},on:{"change":_vm.handleAreaChange,"focus":function (_) { return _vm.$emit('focus', _); }},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    visible: Boolean,
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    grouped: function grouped() {
      if (!this.data.group) {
        return [];
      }
      return this.data.group.filter(function (item) {
        return item.grp_size !== 1;
      });
    },
    ungrouped: function ungrouped() {
      if (!this.data.group) {
        return [];
      }
      return this.data.group.filter(function (item) {
        return item.grp_size === 1;
      });
    },
    groupedCnt: function groupedCnt() {
      return this.grouped.reduce(function (total, current) {
        return total + current.grp_cnt;
      }, 0);
    },
    total: function total() {
      return this.grouped.reduce(function (total, current) {
        return total + current.grp_size * current.grp_cnt;
      }, 0) + this.ungrouped.reduce(function (total, current) {
        return total + current.grp_cnt;
      }, 0);
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onConfirm: function onConfirm() {
      this.$emit('confirm');
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 1960:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  customerid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的客户ID', 'integer', 'blur', false), { min: 1 })],
  projectid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的项目ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入配置名称'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入虚拟任务标题'))],
  customerid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户', 'integer'))],
  projectid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择项目', 'integer'))],
  batchids: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择批次', 'array'))],
  radius: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0整数', 'integer'), { min: 1 })],
  max_tsk_cnt: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于1的整数', 'integer'), { min: 1 })],
  min_tsk_cnt: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于1的整数', 'integer'), { min: 1 })],
  bonus_rate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入非负整数', 'integer'), { min: 0 })],
  min_finish_cnt: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入非负整数', 'integer'), { min: 0 })],
  point_penalty_rate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入非负整数', 'integer'), { min: 0 })]
};

/***/ }),

/***/ 1961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MidanPreviewDialog_vue__ = __webpack_require__(1689);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19aca1e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MidanPreviewDialog_vue__ = __webpack_require__(1968);
function injectStyle (ssrContext) {
  __webpack_require__(1962)
  __webpack_require__(1964)
  this["$style"] = __webpack_require__(1966)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19aca1e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MidanPreviewDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19aca1e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MidanPreviewDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1962:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1963);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6c679fb4", content, true, {});

/***/ }),

/***/ 1963:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MidanPreviewDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1964:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1965);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4171b974", content, true, {});

/***/ }),

/***/ 1965:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".item[data-v-19aca1e2]{margin-bottom:6px}.item span[data-v-19aca1e2]{font-size:16px}", "", {"version":3,"sources":["/workspace/src/views/midan/components/MidanPreviewDialog.vue"],"names":[],"mappings":"AACA,uBAAuB,iBAAiB,CACvC,AACD,4BAA4B,cAAc,CACzC","file":"MidanPreviewDialog.vue","sourcesContent":["\n.item[data-v-19aca1e2]{margin-bottom:6px\n}\n.item span[data-v-19aca1e2]{font-size:16px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1966:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1967);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("852eb920", content, true, {});

/***/ }),

/***/ 1967:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MidanPreviewDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"请确定本次米单配置的分组结果","visible":_vm.visible,"before-close":_vm.closeDialog,"width":"38%"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","justify-content":"space-between"}},[_c('h3',[_vm._v("任务总数量："+_vm._s(_vm.total))]),_vm._v(" "),_c('h3',[_vm._v("创建虚拟任务数量："+_vm._s(_vm.groupedCnt))]),_vm._v(" "),_c('h3',[_vm._v("共需预算："+_vm._s(_vm.data.cost)+"元")])]),_vm._v(" "),_c('h3',[_vm._v("可以组合为米单")]),_vm._v(" "),_vm._l((_vm.grouped),function(item,index){return _c('div',{key:"grouped" + index,staticClass:"item"},[_c('span',[_vm._v(_vm._s(item.grp_size)+"个任务")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.grp_cnt)+"组")])])}),_vm._v(" "),_c('h3',[_vm._v("不可组合为米单")]),_vm._v(" "),_vm._l((_vm.ungrouped),function(item,index){return _c('div',{key:"ungrouped" + index,staticClass:"item"},[_c('span',[_vm._v(_vm._s(item.grp_cnt)+"个任务")])])}),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("确定")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__midan_rules_js__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_area_components_CascaderDistrict__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MidanPreviewDialog_vue__ = __webpack_require__(1961);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CascaderDistrict: __WEBPACK_IMPORTED_MODULE_3__views_area_components_CascaderDistrict__["a" /* default */],
    MidanPreviewDialog: __WEBPACK_IMPORTED_MODULE_4__components_MidanPreviewDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_2__midan_rules_js__["a" /* formRules */],
      form: {
        name: '',
        customerid: 445,
        projectid: '',
        batchid: '',
        title: '',
        radius: '',
        max_tsk_cnt: '',
        min_tsk_cnt: '',
        min_finish_cnt: '',
        bonus_rate: 0,
        point_penalty_rate: '',
        status: 0,
        province_setting: [{
          id: '',
          city_ids: [],
          cities: []
        }],
        project_setting: [{
          id: '',
          batch_ids: []
        }]
      },
      areaid: [],
      showPreview: false,
      previewData: {},
      provinces: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    projectOpts: function projectOpts(state) {
      return state.customerProject;
    }
  }), {
    supportProjectType: function supportProjectType() {
      return this.projectOpts.TYPE_NORMAL;
    }
  }),
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {
    var _this = this;

    this.appendFormRules();
    request('getProvinces').then(function (_ref) {
      var data = _ref.data;

      _this.provinces = data;
    });
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), {
    appendFormRules: function appendFormRules() {
      var _this2 = this;

      var validate = {
        next: 0,
        field: function field(value) {
          if (++validate.next === 4) {
            validate.next = 0;
          } else {
            // 确保不会重复执行，在使用 form.validate 时对每个字段进行了轮询验证
            var next = validate.next;
            setTimeout(function () {
              if (validate.next === next) {
                _this2.$refs.form.validateField(value);
              }
            });
          }
        },
        fail: function fail() {
          validate.next = 0;
        }
      };
    },
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this3 = this;

      request.page('getMidanDetail', { id: id }).then(function (_ref2) {
        var data = _ref2.data;

        data.projectid = '' + data.projectid;
        data.batchid = '' + data.batchid;
        data.radius = data.radius / 1000;
        data.province_setting.forEach(function (item) {
          item.cities = [];
        });
        if (!data.province_setting.length) {
          data.province_setting = [{
            id: '',
            city_ids: []
          }];
        }
        filter.setLoop(_this3.form, data);
        for (var i = 0; i < _this3.form.province_setting.length; i++) {
          _this3.form.province_setting[i].cities = [];
          _this3.selectProvince(i, _this3.form.province_setting[i].id);
        }
      });
    },
    getForm: function getForm() {
      var form = filter.copyJson(this.form);
      form.radius = form.radius * 1000;
      form.province_setting = form.province_setting.map(function (item) {
        return {
          id: item.id,
          city_ids: item.city_ids
        };
      });
      // 如果没有地区信息 则默认全国任务
      if (!form.province_setting.filter(function (item) {
        return item.id;
      }).length) {
        form.province_setting = [];
      }
      if (!form.project_setting.filter(function (item) {
        return item.id;
      }).length) {
        throw Error('请至少选择一个项目');
      }
      return form;
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      if (this.form.max_tsk_cnt < this.form.min_tsk_cnt) {
        this.$message.error('分组最大任务数不能小于分组最小任务数！');
        return;
      }
      this.$refs.form.validate().then(function () {
        if (_this4.form.status > 0) {
          request.common('previewDynamicsettingMidanData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: _this4.id }, _this4.getForm())).then(function (_ref3) {
            var data = _ref3.data;

            _this4.$confirm('\u9884\u8BA1\u9879\u76EE\u51BB\u7ED3\u9884\u7B97\u8C03\u6574\uFF1A' + data + '\u5143', '提示', { type: 'warning' }).then(function () {
              _this4.confirmSetting();
            });
          });
        } else {
          request.common('previewInfo', _this4.getForm()).then(function (_ref4) {
            var data = _ref4.data;

            _this4.showPreview = true;
            _this4.previewData = data;
          });
        }
      }).catch(function (error) {
        _this4.$message.error(error.message || '提交内容填写不正确！');
      });
    },
    confirmSetting: function confirmSetting() {
      this.id ? this.update(this.id) : this.create();
    },
    create: function create() {
      var _this5 = this;

      this.showPreview = false;
      request.common('createMidanData', this.getForm()).then(function (res) {
        _this5.showPreview = false;
        _this5.previewData = [];
        _this5.$confirm(_this5.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this5.resetFields();
        }, function () {
          _this5.$router.push({ path: '/midan/table/' });
        });
      });
    },
    update: function update(id) {
      var _this6 = this;

      if (this.form.status > 0) {
        request.common('updateDynamicsettingMidanData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
          _this6.$confirm(_this6.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
            _this6.$router.push({ path: '/midan/table/' });
          });
        });
      } else {
        request.common('updateMidanData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
          _this6.$confirm(_this6.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
            _this6.$router.push({ path: '/midan/table/' });
          });
        });
      }
    },
    resetFields: function resetFields() {
      this.$refs.form.resetFields();
      this.form.province_setting = [{
        id: '',
        city_ids: [],
        cities: []
      }];
      this.form.project_setting = [{
        id: '',
        batch_ids: []
      }];
    },
    onAddProject: function onAddProject() {
      this.form.project_setting.push({
        id: '',
        batch_ids: []
      });
    },
    onRemoveProject: function onRemoveProject(index) {
      this.form.project_setting.splice(index, 1);
    },
    onAddCity: function onAddCity() {
      this.form.province_setting.push({
        id: '',
        city_ids: [],
        cities: []
      });
    },
    onRemoveCity: function onRemoveCity(index) {
      this.form.province_setting.splice(index, 1);
    },
    onGetProvinceInfo: function onGetProvinceInfo(value) {
      if (value.length === 3) {
        this.form.provinceid = value[0];
        this.form.cityid = value[1];
        this.form.areaid = value[2];
      }
    },
    selectProvince: function selectProvince(index, pid) {
      var _this7 = this;

      if (pid) {
        request.alert('getCities', { pid: pid }).then(function (_ref5) {
          var data = _ref5.data;

          _this7.form.province_setting[index].cities = data;
        });
      } else {
        this.form.province_setting[index].cities = [];
      }
    }
  })
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MidanForm_vue__ = __webpack_require__(2784);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e9d29c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MidanForm_vue__ = __webpack_require__(4544);
function injectStyle (ssrContext) {
  __webpack_require__(4538)
  __webpack_require__(4540)
  this["$style"] = __webpack_require__(4542)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48e9d29c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MidanForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e9d29c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MidanForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4538:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7ceee669", content, true, {});

/***/ }),

/***/ 4539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MidanForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4540:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("090ac869", content, true, {});

/***/ }),

/***/ 4541:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MidanForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4542:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("502bde5f", content, true, {});

/***/ }),

/***/ 4543:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MidanForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/midan/table"}},[_vm._v("米单列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"配置名称","prop":"name"}},[_c('el-input',{attrs:{"disabled":_vm.form.status > 0,"placeholder":"请输入配置名称"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"虚拟任务项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"disabled":_vm.form.status > 0,"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"输入项目名称/编号 关键字搜索","query-request":function (_) { return _vm.getProjectTable(Object.assign({customerid: _vm.form.customerid, type: [_vm.supportProjectType], status: 30}, _)); },"find-request":_vm.getProjectDetail},on:{"change":function () { _vm.form.batchid = '' }},model:{value:(_vm.form.projectid),callback:function ($$v) {_vm.$set(_vm.form, "projectid", $$v)},expression:"form.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"虚拟任务批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"detail","value-key":"id","placeholder":"输批次名称/编号 关键字搜索","disabled":!_vm.form.projectid || _vm.form.status > 0,"query-request":function (_){ return _vm.getBatchTable(Object.assign({projectid:_vm.form.projectid, per_page: 100}, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.form.batchid),callback:function ($$v) {_vm.$set(_vm.form, "batchid", $$v)},expression:"form.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"虚拟任务标题","prop":"title"}},[_c('el-input',{attrs:{"disabled":_vm.form.status > 0,"placeholder":"请输入虚拟任务标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"最大任务数量","prop":"max_tsk_cnt"}},[_c('el-input',{attrs:{"disabled":_vm.form.status > 0,"placeholder":"请输入最大任务数量"},model:{value:(_vm.form.max_tsk_cnt),callback:function ($$v) {_vm.$set(_vm.form, "max_tsk_cnt", $$v)},expression:"form.max_tsk_cnt"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"最小任务数量","prop":"min_tsk_cnt"}},[_c('el-input',{attrs:{"disabled":_vm.form.status > 0,"placeholder":"请输入最小任务数量"},model:{value:(_vm.form.min_tsk_cnt),callback:function ($$v) {_vm.$set(_vm.form, "min_tsk_cnt", $$v)},expression:"form.min_tsk_cnt"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务半径","prop":"radius"}},[_c('el-input',{attrs:{"disabled":_vm.form.status > 0,"placeholder":"请输入任务半径"},model:{value:(_vm.form.radius),callback:function ($$v) {_vm.$set(_vm.form, "radius", $$v)},expression:"form.radius"}},[_c('template',{slot:"append"},[_vm._v("KM")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"province_setting"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"不选择城市，则默认全国范围","placement":"top"}},[_c('span',[_vm._v("生效地区"),_c('i',{staticClass:"el-icon-warning",staticStyle:{"color":"#E6A23C"}})])])],1),_vm._v(" "),_vm._l((_vm.form.province_setting),function(item,index){return _c('div',{key:index,staticStyle:{"margin-top":"8px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('el-select',{staticClass:"width-max",staticStyle:{"width":"30%  !important","margin-right":"4px"},attrs:{"disabled":_vm.form.status > 0,"clearable":"","placeholder":"请选择省"},on:{"change":function (id) {_vm.selectProvince(index, id); item.city_ids = []}},model:{value:(item.id),callback:function ($$v) {_vm.$set(item, "id", $$v)},expression:"item.id"}},_vm._l((_vm.provinces),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.id}})}),1),_vm._v(" "),(_vm.form.status === 0)?[(index !== _vm.form.province_setting.length - 1)?_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){return _vm.onRemoveCity(index)}}},[_vm._v("删除地区")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('el-select',{staticClass:"width-max",staticStyle:{"margin-top":"2px"},attrs:{"disabled":!item.id || _vm.form.status > 0,"multiple":"","clearable":"","placeholder":"请选择市"},model:{value:(item.city_ids),callback:function ($$v) {_vm.$set(item, "city_ids", $$v)},expression:"item.city_ids"}},_vm._l((item.cities),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.id}})}),1),_vm._v(" "),(_vm.form.status === 0)?[(index === _vm.form.province_setting.length - 1)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onAddCity}},[_vm._v("添加地区")]):_vm._e()]:_vm._e()],2)})],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"额外赏金比例","prop":"bonus_rate"}},[_c('el-input',{attrs:{"placeholder":"请输入额外赏金比例"},model:{value:(_vm.form.bonus_rate),callback:function ($$v) {_vm.$set(_vm.form, "bonus_rate", $$v)},expression:"form.bonus_rate"}},[_c('template',{slot:"append"},[_vm._v("%")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"最少完成任务数","prop":"min_finish_cnt"}},[_c('el-input',{attrs:{"disabled":_vm.form.status > 0,"placeholder":"请输入最少完成任务数"},model:{value:(_vm.form.min_finish_cnt),callback:function ($$v) {_vm.$set(_vm.form, "min_finish_cnt", $$v)},expression:"form.min_finish_cnt"}},[_c('template',{slot:"append"},[_vm._v("单")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"零豆惩罚比例","prop":"point_penalty_rate"}},[_c('el-input',{attrs:{"placeholder":"请输入零豆惩罚比例"},model:{value:(_vm.form.point_penalty_rate),callback:function ($$v) {_vm.$set(_vm.form, "point_penalty_rate", $$v)},expression:"form.point_penalty_rate"}},[_c('template',{slot:"append"},[_vm._v("%")])],2)],1),_vm._v(" "),_vm._l((_vm.form.project_setting),function(item,index){return _c('div',{key:index},[_c('el-form-item',[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"请勿添加已使用群组控制的项目","placement":"top"}},[_c('span',[_vm._v("项目"),_c('i',{staticClass:"el-icon-warning",staticStyle:{"color":"#E6A23C"}})])])],1),_vm._v(" "),_c('remote-select',{staticClass:"width-max",staticStyle:{"width":"78.3%  !important"},attrs:{"disabled":_vm.form.status > 0,"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"输入项目名称/编号 关键字搜索","query-request":function (_) { return _vm.getProjectTable(Object.assign({type: [_vm.supportProjectType]}, _)); },"find-request":_vm.getProjectDetail},on:{"change":function () { item.batch_ids = [] }},model:{value:(item.id),callback:function ($$v) {_vm.$set(item, "id", $$v)},expression:"item.id"}}),_vm._v(" "),(_vm.form.status === 0)?[(index !== _vm.form.project_setting.length - 1)?_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){return _vm.onRemoveProject(index)}}},[_vm._v("删除项目")]):_vm._e(),_vm._v(" "),(index === _vm.form.project_setting.length - 1)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onAddProject}},[_vm._v("添加项目")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('el-form-item',[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"不选择批次，则默认该项目下所有批次","placement":"top"}},[_c('span',[_vm._v("任务批次"),_c('i',{staticClass:"el-icon-warning",staticStyle:{"color":"#E6A23C"}})])])],1),_vm._v(" "),_c('remote-select',{staticClass:"width-max",staticStyle:{"width":"78.3%  !important"},attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"detail","value-key":"id","placeholder":"输批次名称/编号 关键字搜索","disabled":!item.id || _vm.form.status > 0,"query-request":function (_){ return _vm.getBatchTable(Object.assign({projectid:item.id, per_page: 100}, _)); },"find-request":_vm.getBatchDetail},model:{value:(item.batch_ids),callback:function ($$v) {_vm.$set(item, "batch_ids", $$v)},expression:"item.batch_ids"}})],1)],1)})],2)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],1),_vm._v(" "),_c('MidanPreviewDialog',{attrs:{"visible":_vm.showPreview,"data":_vm.previewData},on:{"confirm":_vm.confirmSetting,"closeDialog":function($event){_vm.showPreview = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/midan-form.e89f408898954a06c2cf.js